export const exchangeMembersReportLocation = "/reports/memberreport";
